export default "__VITE_ASSET__b439e867__"